module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAMAAACOacfrAAAAM1BMVEUA2OwA3ugA3+oA5O8A7e0RVaIA4esPXaYDxt0Kir4Mf7gNcK8B1+YFtdQGrM8HpMsCzuEmmY/cAAAABXRSTlMB390eHbMqc6sAAABNSURBVAjXTc5BFoAgCEVR1EDR1Pa/2iDIw5vdCR+4MnmpAKSOXs8AhCeK2kF1LdUwtIkqYsF4Wv3EtHHcArvCNBUuoUBl61z/9RI/ewEe0wN4SGTFMAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/checked.png
// module id = YiKO
// module chunks = 1